// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__2ctgX","carousel":"styles_carousel__OTr30","card":"styles_card__1YfV9","cardBody":"styles_cardBody__20Z36","hasAction":"styles_hasAction__31-It"};